import React from 'react';
import { Button } from 'semantic-ui-react';
import './RequestEditModalNote.css';
var defaultProps = {
  onClose: function onClose() {
    return null;
  }
};
export default function RequestEditModalNote(_ref) {
  var onClose = _ref.onClose,
    handlePublishOpen = _ref.handlePublishOpen;
  function clickToPublish() {
    handlePublishOpen();
    onClose();
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "request-edit-modal-note"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-text blue-color"
  }, "Note: Once you 'Sign Up' for your Fisherman Website, you will be able to easily edit content, color and font on your own using the Fisherman Dashboard or by working with our Support Team. \xA0", /*#__PURE__*/React.createElement(Button, {
    id: "publish-now-from-request-button",
    className: "publish-now-from-request-button body-text blue-color",
    onClick: clickToPublish
  }, "Click here"), "\xA0to 'Sign Up' now!"));
}
RequestEditModalNote.defaultProps = defaultProps;